<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>
      <el-button type="primary" @click.native="toggleOrder" :disabled="sendStatus || !canWrite">单据选择</el-button>
      <el-button type="primary" @click.native="save" :disabled="sendStatus || !canWrite">保存</el-button>
      <el-button type="primary" @click.native="orderDel" :disabled="!isSave || !canWrite">删除</el-button>
      <el-button type="primary" @click="openPrint" :disabled="!isSave">打印</el-button>
      <el-button type="primary" @click.native="cancel" :disabled="!sendStatus || !canWrite">取消</el-button>
    </div>
    <el-form :inline="true" :model="data" :line-form="true" label-width="90px" ref="ruleForm" :rules="rules" status-icon>
      <el-row>
        <!-- 单据日期 -->
        <el-form-item label="单据日期:" prop="DocDate">
          <span class="not-edit" v-if="sendStatus" style="width: 180px">{{ $commonJs.toDateString(data.DocDate) }}</span>
          <el-date-picker
            v-else
            v-model="data.DocDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 180px"
            :clearable="false"
            @change="val => previewNo(val)"
          />
        </el-form-item>
        <el-form-item label="单据编码:" prop="DeliveryDocNo">
          <span v-if="Mode == 0 || sendStatus" class="not-edit" style="min-width: 180px">{{ data.DeliveryDocNo }}</span>
          <el-input v-else v-model="data.DeliveryDocNo" placeholder="请输入单据编码" />
        </el-form-item>
        <el-form-item label="客户:" prop="TradeUnitId">
          <span class="not-edit" v-if="sendStatus || isSelect" style="width: 180px">{{ data.FullName }}</span>
          <el-select v-else v-model="data.TradeUnitId" :clearable="!isSelect" :disabled="isSelect" filterable style="width: 180px">
            <div style="max-height: 274px; overflow: scroll; margin-bottom: -17px; margin-right: -17px">
              <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName" @click.native="setTradeunit(item)"></el-option>
            </div>
          </el-select>
        </el-form-item>

        <el-form-item label="发货日期:" prop="DeliveryDate">
          <span class="not-edit" v-if="sendStatus" style="width: 180px">{{ $commonJs.toDateString(data.DeliveryDate) }}</span>
          <el-date-picker v-else v-model="data.DeliveryDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px" :clearable="false" />
        </el-form-item>
        <el-form-item label="车牌:" prop="CarNo">
          <span class="not-edit" v-if="sendStatus" style="width: 180px">{{ data.CarNo }}</span>
          <el-select v-else v-model="data.CarNo" filterable style="width: 180px">
            <!-- <div style="max-height: 274px;overflow: scroll;margin-bottom: -17px;margin-right: -17px;"> -->
            <el-option v-for="item in carList" :key="item.VehicleId" :value="item.LicensePlate" :label="item.LicensePlate" @click.native="setLicense(item)"></el-option>
            <!-- </div> -->
          </el-select>
        </el-form-item>
        <el-form-item label="司机:" prop="Driver">
          <span class="not-edit" style="width: 180px">{{ data.Driver }}</span>
        </el-form-item>
        <el-form-item label="运费:" prop="Freight">
          <span class="not-edit" v-if="sendStatus" style="width: 180px">{{ data.Freight }}</span>
          <el-input v-else type="number" v-model="data.Freight" placeholder="请填写运费" />
        </el-form-item>
        <!-- 制单人 -->
        <el-form-item label="制单人:">
          <span class="not-edit" style="width: 180px">{{ data.MakeEmpName }}</span>
        </el-form-item>
        <!-- 经办人 -->
        <el-form-item label="经办人:" prop="EmpId">
          <span class="not-edit" v-if="sendStatus" style="width: 180px">{{ data.EmpName }}</span>
          <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 180px" />
        </el-form-item>
        <el-form-item label="送货方式:" prop="DeliveryWay">
          <el-select v-model="data.DeliveryWay" style="width: 180px" :disabled="sendStatus">
            <el-option v-for="item in transportList" :key="item.TransportId" :value="item.TransportId" :label="item.TransportName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货地址:" prop="Address">
          <span class="not-edit" style="width: 440px" v-if="sendStatus">{{ data.Address }}</span>
          <el-input v-else type="textarea" v-model="data.Address" maxlength="60" placeholder="请填写地址" :autosize="{ minRows: 1, maxRows: 2 }" style="width: 440px" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:">
            <span v-if="sendStatus">{{ data.Remark }}</span>
            <el-input v-else type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" style="width: 600px" />
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row style="padding: 10px">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-tabs">
          <el-tab-pane label="明细" name="1">
            <el-table
              :key="Math.random()"
              border
              max-height="450"
              :data="tableList"
              class="tableList"
              :row-class-name="tableRowClassName"
              @row-click="addColumn"
              v-keymove="addList"
              :summary-method="summaryFunc"
              show-summary
            >
              <insert-row @on-insert="onInsert" v-if="!sendStatus" />
              <el-table-column align="left" label="存货编号" min-width="140px">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductNo }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="存货名称" min-width="120px">
                <template slot-scope="{ row }">
                  <span v-if="sendStatus">{{ row.ProductName }}</span>
                  <account-select
                    v-else
                    v-model="row.ProductName"
                    :source="DAccount"
                    @select="onSelect($event, row)"
                    :pageSize="pageParams.pageSize"
                    :pageIndex="pageParams.pageIndex"
                    :listTotal="listTotal"
                    @inputText="inputText"
                    @click.native="resetFun"
                    @currentPage="currentPage"
                    :pageType="true"
                  />
                </template>
              </el-table-column>
              <el-table-column align="left" label="批号" min-width="300px">
                <template slot-scope="{ row, $index }">
                  <span v-if="!row.ProductName" style="color: #999">请先选择存货和仓库</span>
                  <span v-else-if="sendStatus">{{ row.BatchNumber }}</span>
                  <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
                  <account-select
                    v-else
                    v-model="row.BatchNumber"
                    :Head="Head"
                    :source="batchList"
                    :listTotal="batchListTotal"
                    :pageType="true"
                    :pageSize="batchPageParams.pageSize"
                    :pageIndex="batchPageParams.pageIndex"
                    @select="onSelBatch($event, row, $index)"
                    @inputText="inputTextBatch($event, row)"
                    @click.native="onOpenBatch($event, row, $index)"
                    @currentPage="currentPageBatch($event, row)"
                    keyword="BatchNumber"
                  />
                </template>
              </el-table-column>
              <el-table-column align="left" label="规格型号">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductSpec }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="属性" min-width="150px">
                <template slot-scope="{ row, $index }">
                  <span v-if="row.SourceNo && !row.PropertyId">{{ row.PropertyName || '' }}</span>
                  <account-select
                    v-else-if="row.UseProcess && !sendStatus"
                    v-model="row.PropertyName"
                    :source="PropertyAccount"
                    :Head="PropertyHead"
                    @select="onPropertySelect($event, row, $index)"
                    :pageSize="pagePropertyParams.pageSize"
                    :pageIndex="pagePropertyParams.pageIndex"
                    :listTotal="listPropertyTotal"
                    @inputText="inputPropertyText"
                    @click.native="resetPropertyFun(row)"
                    @currentPage="currentPropertyPage($event, row)"
                    :pageType="true"
                    keyword="PropertyName"
                  />
                  <span v-else>{{ row.PropertyName }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="颜色" min-width="120px">
                <template slot-scope="{ row }">
                  <span v-if="row.SourceNo && !row.ColorId">{{ row.ColorName || '' }}</span>
                  <el-select v-else-if="row.UseColor && !sendStatus" v-model="row.ColorId" @change="changeColor($event, row)">
                    <el-option v-for="item in row.Colors || []" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName" />
                  </el-select>
                  <span v-else>{{ row.ColorName || '' }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="存货条码" min-width="120px">
                <template slot-scope="{ row }">
                  <span>{{ row.BarCode }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="销售单位" min-width="100px">
                <template slot-scope="{ row, $index }">
                  <el-select v-if="row.Units && row.Units.length > 0 && row.HasGrammage != true" v-model="row.SaUnitId" :disabled="sendStatus">
                    <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
                  </el-select>
                  <span v-else>{{ row.SaUnitName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column align="left" label="发货数" prop="Quantity">
            <template slot-scope="{ row }">
              <span>{{ row.Quantity }}</span>
            </template>
          </el-table-column> -->
              <el-table-column label="装箱规格" prop="PackingSpeciId" align="left" min-width="100">
                <template slot-scope="{ row }">
                  <el-select v-model="row.PackingSpeciId" @change="changeSpeci($event, row)" :disabled="sendStatus">
                    <el-option v-for="item in packingspeciList" :key="item.PackingSpeciId" :label="item.SpeciName" :value="item.PackingSpeciId" :disabled="item.Status == 0"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="每件数" prop="PackingNumber" align="left" min-width="80">
                <template slot-scope="{ row }">
                  <span v-if="row.PackingSpeciId > 0">
                    {{ row.RealPackingNumber > 0 && row.RealPackingNumber != row.PackingNumber ? row.RealPackingNumber : row.PackingNumber }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="件数" prop="PackingQuantity" align="left" min-width="140">
                <template slot-scope="{ row, $index }">
                  <span class="not-edit" v-if="sendStatus">{{ $commonJs.toThousands(row.PackingQuantity) }}</span>
                  <el-input type="text" style="width: 100px" v-else @change="changePackingQuantity($event, row, $index)" v-model="row.PackingQuantity">
                    <!-- <el-button v-if="row.ProductName" style="width: 40px" slot="append" @click="openSales(row, $index)" icon="el-icon-s-order"></el-button> -->
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column align="left" label="实发数" min-width="120px" prop="RealQuantity">
                <template slot-scope="{ row }">
                  <span v-if="sendStatus">{{ $commonJs.toThousands(row.RealQuantity) }}</span>
                  <el-input v-else v-quantity:[option]="option" type="text" v-model="row.RealQuantity" @change="realChange(row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="left" label="库存数">
                <template slot-scope="{ row }">
                  <span>{{ row.StockQuantity }}</span>
                </template>
              </el-table-column>
              <el-table-column label="克重" prop="Grammage" align="right" min-width="100">
                <template slot-scope="{ row, $index }">
                  <span v-if="sendStatus">{{ $commonJs.toThousands(row.Grammage) }}</span>
                  <el-input type="text" v-else-if="row.HasGrammage == true" @change="changeGrammage($event, row, $index)" v-model="row.Grammage"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="left" label="计量单位2" min-width="120px">
                <template slot-scope="{ row, $index }">
                  <!-- <span>{{ row }}{{ $index }}</span> -->
                  <el-select v-if="row.Units && row.Units.length > 0 && row.HasGrammage != true" v-model="row.UnitId2" :disabled="sendStatus">
                    <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
                  </el-select>
                  <span v-else-if="row.UnitType == 0"></span>
                  <span v-else>{{ row.UnitName2 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量2" prop="RealQuantity2" align="right" min-width="100">
                <template slot-scope="{ row, $index }">
                  <span v-if="sendStatus">{{ $commonJs.toThousands(row.RealQuantity2) }}</span>
                  <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.RealQuantity2" @change="changeQuantity2($event, row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column min-width="160" align="left" label="备注">
                <template slot-scope="{ row }">
                  <span v-if="sendStatus">{{ row.Remark }}</span>
                  <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
                </template>
              </el-table-column>
              <el-table-column align="left" label="来源单号" min-width="120px">
                <template slot-scope="{ row }">
                  <span>{{ row.OrderNo }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" v-if="canWrite && !sendStatus" fixed="right" min-width="80px">
                <template slot-scope="{ row, $index }">
                  <!-- <el-button type="text" @click="openSales(row, $index)" v-if="row.ProductId > 0" :disabled="sendStatus">分箱</el-button> -->
                  <el-button type="text" @click.stop="delTableList(row, $index)">删除 </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="汇总" name="2">
            <el-table border class="table_bottom table-line tb-c-head" :data="tableDataSummary" stripe style="margin-top: 18px" show-summary :summary-method="getSummaries">
              <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductNo }}</span>
                </template>
              </el-table-column>
              <el-table-column label="件数" prop="PackingQuantity" align="right" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(row.PackingQuantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计量单位" prop="UnitName" align="left" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ row.UnitName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" prop="Quantity" align="right" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" prop="UnitName2" label="计量单位2" min-width="120px">
                <template slot-scope="{ row }">
                  <span v-if="row.UnitType == 0"></span>
                  <span v-else>{{ row.UnitName2 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="数量2" prop="Quantity2" min-width="120px">
                <template slot-scope="{ row }">
                  <span v-if="row.UnitType == 0"></span>
                  <span v-else>{{ $commonJs.toThousands(row.Quantity2) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane></el-tabs
        >
      </el-row>
      <!-- <el-row>
        <el-form-item label="审核人:" label-width="80px" style="width: 180px">
          {{ data.ReviewEmpName }}
        </el-form-item>
        <el-form-item label="审核时间:" label-width="80px" style="width: 180px">
          {{ $commonJs.toDateString(data.ReviewDate) }}
        </el-form-item>
        <el-form-item label="变更人:" label-width="80px" style="width: 180px">
          {{ data.UpdateEmpName }}
        </el-form-item>
        <el-form-item label="变更日期:" label-width="80px" style="width: 180px">
          {{ $commonJs.toDateString(data.UpdateDate) }}
        </el-form-item>
      </el-row> -->
    </el-form>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <sale-quotation-select ref="saleQuotationSelect" in-dialog selectable multiple @select-multiple="setOrderList" />
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    <sale-order-dialog ref="saleOrderDialog" in-dialog selectable multiple @select-multiple="setOrderList" />
    <order-dialog ref="orderDialog" @save="initerPrice" in-dialog />
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import empDialog from '@/components/personnel/result/record/listDialog'
import accountSelect from '@/components/business/sales/select'
import saleQuotationSelect from '@/components/business/sales/quotation/listDialog'
import saleOrderDialog from '@/components/business/sales/saleorder/listDeliveryDialog'
import optionMixins from '@/mixins/option'
import tradeunitDialog from '@/components/basedata/business/come/listDialog'
import orderDialog from '@/components/business/sales/deliveryrelease/todo/priceDialog'

export default {
  name: 'editdeliveryOrder',
  mixins: [curdMixins, optionMixins],
  components: {
    empDialog,
    accountSelect,
    saleQuotationSelect,
    tradeunitDialog,
    saleOrderDialog,
    orderDialog
  },
  data() {
    return {
      api: require('@/api/sa/deliveryDoc').default,
      adressApi: require('@/api/ba/tradeUnitContact').default,
      pdApi: require('@/api/ba/product').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      transportApi: require('@/api/ba/transport').default,
      code_api: require('@/api/sy/serialCode').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      vehicleApi: require('@/api/ba/vehicle').default,
      packingspeciApi: require('@/api/ba/packingspeci').default,
      propertyApi: require('@/api/ba/property').default,
      initDAccount: [],
      initTotal: 0,
      isSelect: false, // 是否有选单的操作
      DAccount: [],
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      colorList: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      dels: [], // 待删除的存货数组
      data: {
        Products: [],
        Address: '',
        DeliveryDocId: 0,
        DeliveryDocNo: '',
        OrderId: 0,
        // DeliveryDate: "",
        EmpId: 0,
        EmpName: '',
        Remark: '',
        Status: 0,
        DeliveryWay: null,
        FileUrl: '',
        OrderNo: '',
        DocDate: this.$commonJs.getToday(),
        TradeUnitId: null,
        TradeUnitNo: '',
        ShortName: '',
        FullName: '',
        CarNo: '',
        Driver: '',
        Freight: 0,
        Quantity: 0,
        RealQuantity: 0,
        DeliveryStatus: 0,
        MakeEmpId: 0,
        MakeEmpName: ''
        //---------------------------------------------
        // OrderId: 0,
        // DocDate: this.$commonJs.getToday(),
        // DeliveryDocNo: "",
        // service: "",
        // TransportId: null,
        // Address: "",
        // EmpId: null,
        // MakeEmpName: "",
        // DpId: 0,
        // DpName: null,
        // DpNo: null,
        // Person: "",
        // Phone: "",
        // Remark: "",
        // // 生产要求
        // Requirement: "",
        // ReviewEmpName: "",
        // ReviewDate: "",
        // UpdateEmpName: "",
        // UpdateDate: "",
        // TradeUnitId: null,
        // Status: 0,
        // Products: [],
        // IsCloth: false
      },
      isMainUnitId2: false,
      isMainUnitId: false,
      Mode: 0,
      isSave: false,
      service: null,
      productList: [],
      tradeUnitList: [],
      carList: [],
      transportList: [],
      tableList: [
        {
          T: 0,
          DeliveryDocProductId: 0,
          DeliveryDocId: 0,
          OrderProductId: 0,
          Quantity: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          ShortName: '',
          OrderNo: '',
          TradeUnitNo: '',
          TradeUnitShortName: '',
          FullName: '',
          PurchaseQuantity: 0,
          PurchaseQuantity2: 0,
          ProductionQuantity: 0,
          ProductionQuantity2: 0,
          ExecutionQuantity: 0,
          ExecutionQuantity2: 0,
          DeliveryQuatity: 0,
          SaQuantity: 0,
          MouldNo: '',
          ProductId: 0,
          SaUnitId: 0,
          TradeUnitId: 0,
          StockQuantity: 0,
          ExistQuantity: 0,
          UseColor: false,
          SaDocOccupyQuantity: 0,
          ColorName: '',
          Remark: '',
          SaUnitName: '',
          UnitName: '',
          RealQuantity2: null,
          UnitId2: null,
          Grammage: null,
          HasGrammage: null,
          PackingQuantity: null
        }
      ],
      tableDataSummary: [
        {
          ProductNo: '',
          ProductName: '',
          UnitType: 0,
          UnitName: '',
          Quantity: null,
          Price: null,
          Amount: null,
          UnitName2: '',
          Price2: null,
          Quantity2: null,
          PackingQuantity: null
        }
      ],
      optionList: [],
      tableColorShow: true,
      activeName: '1',
      rules: {
        DocDate: [{ required: true, message: '单据日期不能为空' }],
        DeliveryDocNo: [{ required: true, message: '单据编码不能为空' }],
        TradeUnitId: [{ required: true, message: '客户不能为空', trigger: 'change' }],
        //CarNo: [{ required: true, message: '车牌不能为空' }],
        //Freight: [{ required: true, message: '运费不能为空' }],
        DeliveryWay: [{ required: true, message: '送货方式不能为空' }],
        Address: [{ required: true, message: '送货地址不能为空' }],
        EmpId: [{ required: true, message: '经办人不能为空' }],
        Remark: [{ required: true, message: '备注不能为空' }]
      },
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        RealQuantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true
      },
      Head: [
        { Value: 'BatchNumber', Name: '批号', Width: '180' },
        { Value: 'WarehouseName', Name: '仓库', Width: '100' },
        { Value: 'ColorName', Name: '颜色', Width: '80' },
        { Value: 'PropertyName', Name: '属性', Width: '80' },
        //{ Value: "BatchStartDate", Name: "批次起始日期", Width: "100" },
        //{ Value: "ExpireDate", Name: "有效期至", Width: "100" },
        { Value: 'BaseUnitName', Name: '主单位', Width: '80' },
        { Value: 'BaseQuantity', Name: '现存量', Width: '80' }
      ],
      batchListTotal: 0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      batchList: [],
      packingspeciList: [],
      PropertyAccount: [],
      initPropertyAccount: [],
      initPropertyTotal: 0,
      listPropertyTotal: 0,
      pagePropertyParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      PropertyHead: [
        { Value: 'PropertyNo', Name: '属性编码', Width: '150' },
        { Value: 'PropertyName', Name: '属性名称', Width: '150' }
      ]
    }
  },
  computed: {
    isLineAbort() {
      return this.data.DeliveryDocId > 0 && this.data.Products.length > 0 ? false : true
    },
    sendStatus() {
      console.log(this.data.DeliveryStatus, 'DeliveryStatus ')
      return this.data.DeliveryStatus == 1
    },
    canWrite() {
      return this.$permission.canWrite('/business/sales/deliveryrelease')
    }
  },
  mounted() {
    this.callOptionApi().then(res => {
      this.init()
      // this.api.list({}).then((res) => (this.productList = res.Data));
      if (this.$route.params.isSave) this.isSave = true
      if (this.$route.params.mode == 'create' || !this.$route.params.mode) {
        this.createOrder()
      }
      console.log('触发编辑')
      if (this.$route.params.mode == 'edit') {
        this.editOrder(this.$route.params.data.DeliveryDocId)
      }
      if (this.$route.params.mode == 'details') {
        this.editOrder(this.$route.params.data.DeliveryDocId)
      }
    })
  },
  methods: {
    handleClick(tab, event) {
      if (this.activeName == '2') {
        this.tableDataSummary = this.summarizeTableData()
        console.log(this.tableDataSummary)
      }
    },
    summarizeTableData() {
      const summary = {}
      // 遍历所有产品，进行汇总
      console.log('this.tableList', this.tableList)
      this.tableList.forEach(product => {
        if (product.ProductNo) {
          if (!summary[product.ProductNo]) {
            // 如果是第一次遇到该产品，则初始化
            summary[product.ProductNo] = {
              ProductNo: product.ProductNo,
              ProductName: product.ProductName,
              UnitType: product.UnitType,
              UnitName: product.SaUnitName,
              UnitName2: product.UnitName2,
              Quantity: product.RealQuantity,
              Quantity2: product.UnitType == 1 ? product.RealQuantity2 : 0,
              PackingQuantity: product.PackingQuantity,
              count: 1
            }
          } else {
            // 否则，累加数量和总价，并增加计数
            if (product.UnitType == 1 && summary[product.ProductNo].UnitName != product.UnitName) {
              summary[product.ProductNo].Quantity += product.RealQuantity
              summary[product.ProductNo].Quantity2 += product.RealQuantity2
            } else {
              summary[product.ProductNo].Quantity += product.RealQuantity
              if (product.UnitType == 1) summary[product.ProductNo].Quantity2 += product.RealQuantity2
            }
            summary[product.ProductNo].PackingQuantity += product.PackingQuantity
            summary[product.ProductNo].count++
          }
        }
      })

      // 将汇总结果转换为数组，并计算平均单价
      return Object.values(summary).map(sum => ({
        ProductNo: sum.ProductNo,
        ProductName: sum.ProductName,
        UnitType: sum.UnitType,
        UnitName: sum.UnitName,
        UnitName2: sum.UnitName2,
        Quantity: sum.Quantity,
        Quantity2: sum.Quantity2,
        PackingQuantity: sum.PackingQuantity
      }))
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity', 'Quantity2', 'PackingQuantity'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          console.log('values', values)
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            //金额 固定2位小数
            const arr2 = ['Amount']
            var v = sums[index]
            if (arr2.indexOf(field.property) != -1) {
              v = v.toFixed(2)
              let vStr = v.toString().split('.')
              if (Number(vStr[1]) <= 0) v = vStr[0]
            }
            if (v > 0) {
              v = Number(v).toLocaleString()
            }
            sums[index] = v
          } else {
            sums[index] = '-'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    onPropertySelect(val, row, index) {
      console.log(val, row, 'onPropertySelect')

      if (val) {
        row.PropertyId = val.PropertyId
        row.PropertyName = val.PropertyName
        row.PropertyNo = val.PropertyNo
      } else {
        row.PropertyNo = ''
        row.PropertyId = null
        row.PropertyName = null
      }

      this.$nextTick(() => {
        if (row.ProductId > 0) {
          var BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
          row.BarCode = BarCode
          console.log(row.BarCode, 'onPropertySelect')
          //(this.tableList, index, row)
          this.$set(row, 'BarCode', BarCode)
          this.tableList.splice(index, 1, row)
          this.$forceUpdate()
        }
      })
    },
    resetPropertyFun(row) {
      this.pagePropertyParams.pageIndex = 1
      this.PropertyAccount = this.initPropertyAccount
      this.listPropertyTotal = this.initPropertyTotal

      let param = { pageIndex: 1, pageSize: 7, Status: 1 }

      this.propertyApi.list(param).then(res => {
        if (res.Code == 0) {
          this.PropertyAccount = res.Data
          this.listPropertyTotal = res.Count
        }
      })
    },
    currentPropertyPage({ val, text1 }, row) {
      console.log(val, text1, row)
      this.pagePropertyParams.pageIndex = val

      let param = { pageIndex: val, pageSize: 7, Status: 1, PropertyName: text1 }

      this.propertyApi.list(param).then(res => {
        if (res.Code == 0) {
          this.PropertyAccount = res.Data
          this.listPropertyTotal = res.Count
        }
      })
    },
    inputPropertyText(text) {
      this.propertyApi
        .list({
          PageIndex: 1,
          PageSize: 7,
          PropertyName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.PropertyAccount = res.Data
            this.listPropertyTotal = res.Count
          }
        })
    },
    //单据保存回显
    initerPrice(data) {
      console.log(data, 'initerPrice')
      if (data) {
        console.log(data, 'saved')

        this.tableList.splice(data.index, 1)
        console.log(this.tableList, 'this.tableList')
        var arr = []
        data.list.forEach(item => {
          let o = {
            ...item
          }
          console.log(o, 'separate')
          arr.push(o)
        })
        this.tableList.unshift(...arr)

        this.tableList.forEach((i, d) => {
          i.index = d
        })
      }
    },
    openSales(row, index) {
      this.currentRow = row
      this.currentIndex = index
      let o = { ...row, index }
      this.$refs.orderDialog.openEdit(o)
      // this.$refs.orderDialog.open();
    },
    changePackingQuantity(val, row, index) {
      if (row.PackingNumber > 0) {
        if (val) {
          row.RealQuantity = parseInt(val * row.PackingNumber)
          if (row.HasGrammage == true) {
            row.RealQuantity2 = row.RealQuantity * row.Rate
          }
        }
      }
    },
    changeSpeci(val, row) {
      let item = this.packingspeciList.filter(item => {
        return item.PackingSpeciId === val
      })[0]
      console.log(item, row, 'changeSpeci')
      if (item) {
        row.PackingNumber = item.PackingNumber
        row.RealPackingNumber = item.PackingNumber
        if (row.RealQuantity) {
          row.PackingQuantity = parseInt(row.RealQuantity / row.PackingNumber)
        }
      }
    },
    onInsert(e) {
      let { type, index } = e

      this.interpolate(null, index, type)
    },
    interpolate(row, index, type = '') {
      let o = {
        T: 0,
        DeliveryDocProductId: 0,
        DeliveryDocId: 0,
        OrderProductId: 0,
        Quantity: 0,
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        ShortName: '',
        OrderNo: '',
        TradeUnitNo: '',
        TradeUnitShortName: '',
        FullName: '',
        PurchaseQuantity: 0,
        PurchaseQuantity2: 0,
        ProductionQuantity: 0,
        ProductionQuantity2: 0,
        ExecutionQuantity: 0,
        ExecutionQuantity2: 0,
        DeliveryQuatity: 0,
        SaQuantity: 0,
        MouldNo: '',
        ProductId: 0,
        SaUnitId: 0,
        TradeUnitId: 0,
        StockQuantity: 0,
        ExistQuantity: 0,
        UseColor: false,
        SaDocOccupyQuantity: 0,
        ColorName: '',
        Remark: '',
        SaUnitName: '',
        UnitName: '',
        RealQuantity2: null,
        UnitId2: null,
        Grammage: null,
        HasGrammage: null
      }
      if (type == 'down') {
        index = index + 1
      }
      this.tableList.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.tableList))
      this.tableList = []
      this.$nextTick(() => {
        this.tableList = copy
      })
    },
    openTradeunit() {
      if (!this.isSelect) {
        this.$refs.tradeunitDialog.open().then(that => {
          that.getData({ TradeUnitTypes: [0, 2] })
        })
      }
    },
    previewNo(val = this.$commonJs.getToday()) {
      this.code_api.previewNo('发货通知单', val).then(res => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.DeliveryDocNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取订单编码失败')
        }
      })
    },
    init() {
      this.tradeUnitApi.list({ TradeUnitTypes: [0, 2], Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.tradeUnitList = res.Data
        }
      })
      this.packingspeciApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.packingspeciList = res.Data
        }
      })
      this.vehicleApi.list({ Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.carList = res.Data
        }
      })
      this.transportApi.list({}).then(res => {
        if (res.Code == 0) this.transportList = res.Data
      })
      this.pdApi.list({ Property: '销售', pageIndex: 1, pageSize: 7, Status: 1 }).then(res => {
        this.DAccount = res.Data
        this.initDAccount = res.Data
        this.listTotal = res.Count
        this.initTotal = res.Count
      })
      this.callOptionApi()
    },
    createOrder() {
      const user = this.$store.state.user
      if (user) {
        this.data.EmpId = user.empId
        this.data.EmpName = user.name
        this.data.MakeEmpId = user.id
        this.data.MakeEmpName = user.name
      }
      if (this.tableList.length == 0) this.addList()
      this.previewNo()
    },
    editOrder(data, type = 0) {
      console.log('执行编辑', data)
      this.api.info(data).then(res => {
        if (res.Code === 0) {
          this.isSave = true
          this.data = res.Data
          this.tableList = res.Data.Products?.map(item => ((item.T = 3), item))
          if (this.tableList.length > 0) {
            this.tableList.forEach(item => {
              console.log(item, 'addList')
              item.IsBatchNumber = item.BatchNumber ?? false
              if (item.Units.length > 0) {
                item.UnitType = 1
                item.Units.forEach(item1 => {
                  if (item1.ChangeType == 1) item.ChangeType = item1.ChangeType
                })
                if (item.SaUnitId) {
                  let index = this.getUnitIndex(3, item.Units, item.SaUnitId)
                  let data = this.getUnitValue(item.Units, index)
                  let assistIndex = 0
                  let assistData = {}
                  item.IsMain = data.IsMain
                  item.SaUnitName = data.UnitName
                  if (data.IsMain) {
                    assistIndex = this.getUnitIndex(2, item.Units)
                    assistData = this.getUnitValue(item.Units, assistIndex)
                    item.Rate = assistData.Rate.toFixed(5)
                  } else {
                    assistIndex = this.getUnitIndex(1, item.Units)
                    assistData = this.getUnitValue(item.Units, assistIndex)
                    item.Rate = data.Rate.toFixed(5)
                  }
                  item.UnitId2 = assistData.UnitId
                  item.UnitName2 = assistData.UnitName
                } else {
                  let untiLength = item.Units.length
                  let mainData = []
                  let noMainData = []
                  for (let i = 0; i < untiLength; ++i) {
                    if (item.Units[i].IsMain) {
                      mainData.push(item.Units[i])
                    } else {
                      noMainData.push(item.Units[i])
                    }
                  }
                  item.SaUnitId = mainData[0].UnitId
                  item.SaUnitName = mainData[0].UnitName
                  item.UnitId2 = noMainData[0].UnitId
                  item.UnitName2 = noMainData[0].UnitName
                  item.Rate = noMainData[0].Rate.toFixed(5)
                  item.IsMain = true
                }
              }
            })
          }

          if (res.Data.Products.length == 0) this.addList()
        }
      })
    },
    async toggleOrder() {
      const res = await this.sourceTypeApi.info('发货通知单')
      let OrderType = res.SourceTypeId
      return this.$refs.saleOrderDialog.open().then(that => {
        if (this.data.FullName) that.getData({ TradeUnitName: this.data.FullName, OrderTypeFilter: OrderType })
        else that.getData({ OrderTypeFilter: OrderType })
      })
      // const res = await this.sourceTypeApi.info("销售订单");
      // let OrderType = res.SourceTypeId;

      // let that = await this.$refs.saleQuotationSelect.open();
      // if (this.data.FullName) {
      //   that.getData({ TradeUnitName: this.data.FullName });
      // } else {
      //   that.getData({ OrderType });
      // }
    },
    // 获取进货单明细
    async setOrderList(data) {
      if (data.Address) {
        this.data.Address = data.Address
      }
      if (data.TradeUnitId > 0) {
        this.data.FullName = data.FullName
        this.data.TradeUnitId = data.TradeUnitId
      }
      if (data.TransportId) {
        this.data.DeliveryWay = data.TransportId
      }
      // let Quantity = this.tableList.map((i) => i.ProductId);
      console.log('===data=====', data)
      var addList = []
      var has = false
      data.List.forEach(e => {
        var obj = this.tableList.find(x => x.SourceNo == data.Order && x.ColorId == e.ColorId && x.PropertyId == e.PropertyId && x.ProductId == e.ProductId)
        if (obj) {
          has = true
        } else {
          addList.push({
            PurchaseQuantity: 0,
            PurchaseQuantity2: 0,
            ProductionQuantity: 0,
            ProductionQuantity2: 0,
            ExecutionQuantity: 0,
            ExecutionQuantity2: 0,
            StockQuantity: 0,
            ExistQuantity: 0,
            Requirement: '',
            ...e,
            T: 0,
            DocNo: '',
            UnitType: e.UnitType,
            SourceNo: data.Order,
            Quantity: e.SaQuantity - e.ExecutionQuantity || 0,
            RealQuantity2: null,
            UnitId2: e.UnitId2,
            Grammage: e.Grammage,
            HasGrammage: e.HasGrammage,
            Units: e.Units,
            SaUnitId: e.BaseUnitId,
            IsBatchNumber: e.BatchNumber ? true : false,
            BatchNumber: e.BatchNumber
          })
        }
      })
      if (has) this.$message.error('已过滤相同的产品记录')
      var arr = []
      addList.forEach(item => {
        console.log(item, 'addList')

        if (item.Units.length > 0) {
          item.Units.forEach(item1 => {
            if (item1.ChangeType == 1) item.ChangeType = item1.ChangeType
          })
          item.UnitType = 1
          if (item.SaUnitId) {
            let index = this.getUnitIndex(3, item.Units, item.SaUnitId)
            let data = this.getUnitValue(item.Units, index)
            let assistIndex = 0
            let assistData = {}
            item.IsMain = data.IsMain
            item.SaUnitName = data.UnitName
            if (data.IsMain) {
              assistIndex = this.getUnitIndex(2, item.Units)
              assistData = this.getUnitValue(item.Units, assistIndex)
              item.Rate = assistData.Rate.toFixed(5)
            } else {
              assistIndex = this.getUnitIndex(1, item.Units)
              assistData = this.getUnitValue(item.Units, assistIndex)
              item.Rate = data.Rate.toFixed(5)
            }
            item.UnitId2 = assistData.UnitId
            item.UnitName2 = assistData.UnitName
          } else {
            let untiLength = item.Units.length
            let mainData = []
            let noMainData = []
            for (let i = 0; i < untiLength; ++i) {
              if (item.Units[i].IsMain) {
                mainData.push(item.Units[i])
              } else {
                noMainData.push(item.Units[i])
              }
            }
            item.SaUnitId = mainData[0].UnitId
            item.SaUnitName = mainData[0].UnitName
            item.UnitId2 = noMainData[0].UnitId
            item.UnitName2 = noMainData[0].UnitName
            item.Rate = noMainData[0].Rate.toFixed(5)
            item.IsMain = true
          }
        }
        if (item.PackInfos) {
          item.PackInfos.forEach(x => {
            arr.push({
              ...item,
              PackingQuantity: x.PackingQuantity,
              PackingNumber: x.PackingNumber,
              RealPackingNumber: x.RealPackingNumber,
              RealQuantity: x.RealQuantity,
              RealQuantity2: x.RealQuantity2,
              PackingSpeciId: x.PackingSpeciId,
              PropertyId: x.PropertyId,
              ColorId: x.ColorId,
              BarCode: x.BarCode,
              SpeciName: x.SpeciName
            })
          })
        } else {
          arr.push({ ...item })
        }
      })

      this.tableList.unshift(...arr)
      if (this.data.TradeUnitId) {
        this.isSelect = true
      }
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      this.pdApi
        .list({
          Property: '销售',
          pageIndex: val,
          pageSize: 7,
          Status: 1,
          ProductName: text1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    inputText(text) {
      this.pdApi
        .list({
          Property: '销售',
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 选择存货名称
    onSelect(e, row) {
      console.log('e', e)
      // if (this.data.TradeUnitId === null) {
      //   row.ProductName = "";
      //   return this.$message.warning("请先选择客户");
      // }

      if (row.SourceNo && row.ProductId !== e.ProductId) {
        row.SourceNo = ''
        row.Quantity = row.RealQuantity
      }
      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1
      ;(row.Grammage = e.Grammage), (row.HasGrammage = e.HasGrammage), (row.Variable = e.Variable)

      row.IsBatchNumber = e.BatchNumber ?? false
      row.BatchNumber = null
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null
      row.ProductNo = e.ProductNo
      row.ProductName = e.ProductName
      row.ProductId = e.ProductId
      row.ProductSpec = e.ProductSpec
      row.SaUnitId = e.BaseUnitId
      row.UnitId = e.BaseUnitId
      row.SaUnitName = e.BaseUnitName
      row.UseColor = e.UseColor
      row.Colors = e.Colors
      row.ExistQuantity = e.ExistQuantity
      ;(row.StockQuantity =
        e.StockQuantity ??
        0(
          // row.IsCloth = false;
          (row.IsMain = false)
        )), //是否为浮动
        (row.ChangeType = 0), //是否浮动
        (row.Units = e.Units)
      row.UnitType = 0
      // let findIndex = "";
      row.ChangeType = 0
      // row.rightChangeType = 0;
      if (e.Units.length === 0) {
        row.UnitId2 = 0
        row.SaUnitName = e.BaseUnitName
        row.UnitName2 = ''
        row.Rate = 0
        row.Quantity2 = 0
      } else {
        row.UnitType = 1
        e.Units.forEach(item => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType
        })
        if (row.SaUnitId) {
          let index = this.getUnitIndex(3, e.Units, row.SaUnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain
          row.SaUnitName = data.UnitName
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = assistData.Rate.toFixed(5)
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = data.Rate.toFixed(5)
          }
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length
          let mainData = []
          let noMainData = []
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.SaUnitId = mainData[0].UnitId
          row.SaUnitName = mainData[0].UnitName
          row.UnitId2 = noMainData[0].UnitId
          row.UnitName2 = noMainData[0].UnitName
          row.Rate = noMainData[0].Rate.toFixed(5)
          row.IsMain = true
        }
        console.log(row, 'onSelect')
        // if (row.SaUnitId) {
        //   let IsMainIndex = 0;
        //   let noMainIndex = 0;
        //   findIndex = e.Units.findIndex((el) => row.SaUnitId == el.UnitId); //获取当前带出的索引
        //   row.ChangeType = e.Units[findIndex].ChangeType; //获取带出的单据的type 如果是浮动 会是1

        //   IsMainIndex = e.Units.findIndex((el) => el.IsMain == true); //主单位的索引
        //   noMainIndex = e.Units.findIndex((el) => el.IsMain == false); //不是主单位的索引
        //   if (findIndex == IsMainIndex) {
        //     //判断当前销售单位是否为主单位
        //     row.UnitId2 = e.Units[noMainIndex].UnitId;
        //     row.UnitName2 = e.Units[noMainIndex].UnitName;
        //     row.Rate = this.getIinvexchrate(e.Units[noMainIndex].Rate)
        //     row.ChangeType = e.Units[noMainIndex].ChangeType;
        //     row.IsMain = true;
        //   } else {
        //     //如果当前是赋单位
        //     row.UnitId2 = e.Units[IsMainIndex].UnitId;
        //     row.UnitName2 = e.Units[IsMainIndex].UnitName;
        //     row.Rate = this.getIinvexchrate(e.Units[noMainIndex].Rate);
        //     row.IsMain = false;
        //   }
        // } else {
        //   let untiLength = e.Units.length;
        //   let mainData = [];
        //   let noMainData = [];
        //   for (let i = 0; i < untiLength; ++i) {
        //     if (e.Units[i].IsMain) {
        //       mainData.push(e.Units[i]);
        //     } else {
        //       noMainData.push(e.Units[i]);
        //     }
        //   }
        //   row.SaUnitId = mainData[0].UnitId;
        //   row.SaUnitName = mainData[0].UnitName;
        //   row.UnitId2 = noMainData[0].UnitId;
        //   row.UnitName2 = noMainData[0].UnitName;
        //   row.Rate = this.getIinvexchrate(noMainData[0].Rate)
        //   row.IsMain = true;
        // }
      }

      // this.api
      //   .productPrice({
      //     TradeUnitId: this.data.TradeUnitId,
      //     ProductId: e.ProductId,
      //   })
      //   .then((res) => {
      //     if (res.Data) {
      //       row.SalePrice = res.Data.SalePrice;
      //       row.RetailPrice = res.Data.RetailPrice;
      //       row.PurchasePrice = res.Data.PurchasePrice;
      //       //QuotationPrice
      //       row.QuotedPrice = res.Data.QuotationPrice;
      //       row.Price = res.Data.QuotationPrice;
      //       row.TaxPrice = res.Data.QuotationPrice;
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    addColumn(row, column) {
      // if (row.index === this.tableList.length - 1) {
      //   this.addList();
      // }
    },
    RestartOrder() {
      // this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this))
      this.init()
      this.createOrder()
      // this.addList();
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate()
      }, 30)
    },
    orderUpdate() {
      this.$message.success('取消')
      this.data.DeliveryStatus = 0
      // this.$confirm("确认取消吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     this.api.updateDeliveryStatus({ DeliveryDocId: this.data.DeliveryDocId, DeliveryStatus: 0 }).then(res => {
      //       if(res.Code==0) {
      //         this.data.DeliveryStatus  = 0;
      //         this.$message.success(res.Msg);
      //       } else this.$message.error(res.Msg);
      //     })
      //   })
      //   .catch(() => { });
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.DeliveryDocId == 0) {
        this.$message.warning('订单未保存')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.api.delete({ Id: this.data.DeliveryDocId }).then(res => {
            if (res.Code === 0) this.RestartOrder()
            res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)
          })
        })
        .catch(() => {})
    },
    delTableList(row, index) {
      if (row.T !== 0) {
        row.T = 2
        this.dels.push(row)
      }
      this.tableList.splice(index, 1)

      if (this.tableList.length === 0) this.addList()
      if (this.tableList.length === 0) {
        this.isSelect = false
      }
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    setEmp(data) {
      console.log(data)
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
      this.data.DpId = data.DpId
      this.data.DpName = data.DpName
      this.data.DpNo = data.DpNo
    },
    setTradeunit(data) {
      console.log(data, 'data')
      this.data.TradeUnitId = data.TradeUnitId
      this.data.FullName = data.FullName
      this.data.TradeUnitType = data.TradeUnitType
      // this.data.Address = "";
      // if (!this.data.Address) {
      //   let params = {
      //     pageIndex: 1,
      //     pageSize: 10,
      //     TradeUnitId: this.data.TradeUnitId,
      //   };
      //   params = JSON.parse(JSON.stringify(params));
      //   this.adressApi.list(params).then((res) => {
      //     if (res.Code === 0) {
      //       this.data.Address = res.Data[0].ArrivalAddress;
      //     }
      //     if (res.Code === 1) {
      //       this.$message.error(res.Msg);
      //     }
      //   });
      // }
    },
    setLicense(item) {
      this.data.Driver = item.Owner
    },
    openPrint() {
      let newpage = this.$router.resolve({
        path: '/deliveryPrint?id=' + this.data.DeliveryDocId
      })
      window.open(newpage.href, '_blank')
    },
    cancel() {
      this.$confirm('确认操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.api.updateDeliveryStatus({ DeliveryDocId: this.data.DeliveryDocId, DeliveryStatus: 0 }).then(res => {
            if (res.Code == 0) {
              this.data.DeliveryStatus = 0
              this.$message.success(res.Msg)
            } else this.$message.error(res.Msg)
          })
        })
        .catch(() => {})
    },
    save(type = 0) {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return false
        const Product = JSON.parse(JSON.stringify(this.data.Products))
        const TableList = JSON.parse(JSON.stringify(this.tableList))

        console.log('Product', Product)
        console.log('TableList', TableList)
        // 清除没有产品的数据
        if (TableList.length > 0 && TableList[0].ProductName != '') {
        } else {
          this.$message({ type: 'warning', message: '明细列表不能为空' })
          return
        }
        this.tableList = this.tableList.filter(i => i.ProductId != 0)
        for (let i = 0; i <= this.tableList.length - 1; i++) {
          var item = this.tableList[i]
          if (item.UseColor && !item.ColorId) {
            this.$message.error(`存货【${item.ProductName}】颜色不能为空`)
            return
          }
          if (!(item.RealQuantity > 0)) return this.$message.warning('实发数需大于0')
          if (item.RealQuantity > item.Quantity) return this.$message.warning('实发数不能超过发货数')
        }

        //if (this.tableList.filter((i) => i.DeliveryDate == "").length !== 0)
        // return this.$message.warning("交货日期不能为空");
        //

        let updateList = this.tableList.filter(i => i.T == 1)
        let addList = this.tableList.filter(i => i.T == 0)
        this.data.Products = [...addList, ...this.dels, ...updateList]

        this.data.Products.forEach(item => {
          if (!item.ColorId) item.ColorId = 0
          item.Colors = item.Colors || []
          item.Units = item.Units || []
        })
        // 等于空设置为0
        const sub = JSON.parse(JSON.stringify(this.data))
        sub.Products.forEach(item => {
          Object.keys(item).forEach(key => {
            if (
              item[key] == null &&
              key !== 'LineAbortDate' &&
              key !== 'DeliveryDate' &&
              key !== 'Remark' &&
              key !== 'ClothDate' &&
              key !== 'ClothMakeDate' &&
              key !== 'ClothMakeEmpName' &&
              key !== 'FinishDate' &&
              key !== 'ClothDocDate'
            ) {
              item[key] = 0
            }
          })
        })
        this.api
          .save(sub)
          .then(res => {
            if (res.Code === 0) {
              const id = res.Data === 0 ? this.data.DeliveryDocId : res.Data
              this.isSave = true
              this.editOrder(id, type)
              if (type !== 1) {
                this.$message.success('保存成功')
              }
            }
            if (res.Code === 1) {
              this.tableList = TableList
              this.ProductModels = Product
              this.data.Products = Product
              this.$message.error(res.Msg)
            }
          })
          .catch(err => {
            this.tableList = TableList
            this.ProductModels = Product
            this.data.Products = Product
          })
      })
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    realChange(row) {
      if (!row.SourceNo) {
        row.Quantity = row.RealQuantity
      }
      if (row.T !== 0) {
        row.T = 1
      }

      if (row.Units.length > 0) {
        if (row.IsMain) {
          if (row.HasGrammage == true) {
            row.RealQuantity2 = this.getQuantity(row.RealQuantity * row.Rate)
          } else {
            row.RealQuantity2 = this.getQuantity(row.RealQuantity / row.Rate)
          }
        } else {
          if (row.HasGrammage == true) {
            row.RealQuantity2 = this.getQuantity(row.RealQuantity / row.Rate)
          } else {
            row.RealQuantity2 = this.getQuantity(row.RealQuantity * row.Rate)
          }
        }
      }

      if (row.PackingSpeciId > 0) {
        if (row.PackingNumber > 0) {
          row.PackingQuantity = parseInt(row.RealQuantity / row.PackingNumber)
        }
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)
      if (row.IsMain == false) {
        if (row.ChangeType == 1) {
          if (row.HasGrammage == true) {
            row.RealQuantity = parseInt(this.getQuantity(data * row.Rate))
          } else {
            row.Rate = this.getIinvexchrate(data / row.RealQuantity)
          }
        } else {
          console.log('数量1=数量2/换算率')
          if (row.RealQuantity === 0) {
            row.RealQuantity = this.getQuantity(data * row.Rate)
          } else {
            row.RealQuantity = this.getQuantity(data / row.Rate)
          }
        }
      } else {
        if (row.ChangeType == 1) {
          if (row.HasGrammage == true) {
            row.RealQuantity = parseInt(this.getQuantity(data / row.Rate))
          } else {
            row.Rate = this.getIinvexchrate(row.RealQuantity / data)
          }
        } else {
          console.log('数量1=数量2*换算率')

          row.RealQuantity = this.getQuantity(data * row.Rate)
        }
      }
      if (row.PackingSpeciId > 0) {
        if (row.PackingNumber > 0) {
          row.PackingQuantity = parseInt(row.RealQuantity / row.PackingNumber)
        }
      }
    },
    //更改克重
    changeGrammage(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') return
      console.log('row', row)
      this.editT(row)
      if (row.UnitType == 1) {
        if (row.HasGrammage == true) {
          row.Rate = Number((row.Grammage / row.Variable).toFixed(5))
          console.log('row.IsMain1', row.IsMain, Number(row.Rate))
          if (row.IsMain) {
            row.RealQuantity2 = this.getQuantity(row.RealQuantity * Number(row.Rate))
            console.log('row.IsMain1', row.IsMain, Number(row.Rate))
          } else {
            row.RealQuantity2 = this.getQuantity(row.RealQuantity / Number(row.Rate))
          }
        }
      }
    },
    changeColor(e, row) {
      var obj = row.Colors.find(x => x.ColorId == e)
      if (obj) row.ColorName = obj.ColorName
      row.SourceNo = ''
      row.Quantity = row.RealQuantity
      if (row.T !== 0) {
        row.T = 1
      }
    },
    addList() {
      this.tableList.push({
        T: 0,
        DeliveryDocProductId: 0,
        DeliveryDocId: 0,
        OrderProductId: 0,
        Quantity: 0,
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        ShortName: '',
        OrderNo: '',
        TradeUnitNo: '',
        TradeUnitShortName: '',
        FullName: '',
        PurchaseQuantity: 0,
        PurchaseQuantity2: 0,
        ProductionQuantity: 0,
        ProductionQuantity2: 0,
        ExecutionQuantity: 0,
        ExecutionQuantity2: 0,
        DeliveryQuatity: 0,
        SaQuantity: 0,
        MouldNo: '',
        ProductId: 0,
        SaUnitId: 0,
        TradeUnitId: 0,
        StockQuantity: 0,
        ExistQuantity: 0,
        UseColor: false,
        SaDocOccupyQuantity: 0,
        ColorName: '',
        Remark: '',
        SaUnitName: '',
        UnitName: '',
        RealQuantity2: null,
        UnitId2: null,
        Grammage: null,
        HasGrammage: null
      })
    },
    summaryFunc(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if ((index == 6 || index == 11 || index == 12) && !values.every(value => isNaN(value))) {
          var v = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return Math.floor((prev + curr) * 100) / 100
            } else {
              return prev
            }
          }, 0)
          sums[index] = v
        } else {
          sums[index] = ''
        }
      })

      return sums
    },

    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      // row.BatchNumber = ''
      this.batchPageParams.pageIndex = 1
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.ColorId,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 选择批号 */
    onSelBatch(e, row, index) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = e.BatchNumber
      // if(row.BatchNumber !== e.BatchNumber){
      //   row.BatchNumber = e.BatchNumber
      // }
      console.log(this.tableList[index].BatchNumber)
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.ColorId,
        BatchNumber: row.BatchNumber,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },

    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.ColorId,
        ProductName: row.ProductName,
        pageIndex: val,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 批号起始日期 */
    changeBatchStartDate(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 100px;
  // text-align: center;
  // border-bottom: 1px solid #e4e7ed;
  min-height: 28px;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
